<template>
  <div class="w-100 bg-white m-b-6">
    <a id="browse" class="ANCHOR"></a>
    <div class="container p-y-6">
      <div class="h3 text-bold p-x-1:mo p-b-2">
        <span>Find Services You Can Request</span>
      </div>
      <div class="d-flex jc-center">
        <div class="SERVICE-SECTION">
          <hierarchy-card
              v-for="(hierarchy, index) in serviceHierarchies"
              :hierarchy="hierarchy"
              :key="index"
              :current-index="currentIndex"
              :index="index"
              @handle-click="handleClick(index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HierarchyCard from './components/HierarchyCard';

export default {

  name: 'services-offered-section',
  components: { HierarchyCard },
  data () {
    return {
      currentIndex: -1,
    };
  },
  computed: {
    ...mapGetters('homepage/hierarchies', [
      'serviceHierarchies',
    ]),
  },
  methods: {
    handleClick (index) {
      this.currentIndex = this.currentIndex === index ? -1 : index;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
.ANCHOR {
  display: block;
  position: relative;
  top: -75px;
  visibility: hidden;
}
.SERVICE-SECTION {
  display: grid;
  grid-gap: 3*$unit;
  grid-template-columns: repeat(4, 285px);
  grid-auto-flow: row;
  grid-template-rows: auto;
  justify-content: center;
  font-size: 14px;
  @include desktop-only(){
    grid-template-columns: repeat(4, 220px);
    grid-gap: 3*$unit;
  }
  @include tablet-only(){
    grid-template-columns: repeat(3, 220px);
    grid-gap: 4.5*$unit;
  }
  @include mobile-only(){
    grid-template-columns: repeat(1, 280px);
    grid-gap: 2*$unit;
  }
}
</style>
